export default {
  data() {
    return {
      customSliderInternalValue: this.actualValue.value,
      customInputValue: [...this.actualValue.value], // set default value
      customInputResetValue: this.actualValue.value, // use for reset input value, updated when the input value is valid
      customDisplayValue: '',
    }
  },
  computed: {
    customInput() {
      // will be wrapped by FilterDropdownWrapper instead of multiselect
      // prevent closing dropdown by clicking input field
      return this.mode.includes('custom-input');
    },
    customDropdownSize() {
      // usage for FilterDropdownWrapper for custom dropdown content width
      // if props mode includes 'custom-size-xxx' (in px)
      // default is 300px
      if (this.mode.includes('custom-size')) {
        const size = this.mode.match(/custom-size-(\d+)/);
        return size ? size[1] : '300';
      }
      return '300';
    },
  },
  watch: {
    actualValue: {
      handler(newValue) {
        if ( this.customInput ) {
          // this.customSliderInternalValue = newValue.value;
          this.customInputResetValue = newValue.value; // update reset value only
          this.updateDisplayValue(newValue.value);
          this.resetCustomValues();
        }
      },
      deep: true,
    },
    // customInputValue: {
    //   handler(newValue) {
    //     this.customSliderInternalValue = [...newValue];
    //   },
    //   deep: true,
    // },
  },
  mounted() {
    if ( this.customInput ) {
      this.updateDisplayValue(this.actualValue.value);
    this.customInputValue = [...this.customSliderInternalValue]; // set default value
    }
  },
  methods: {
    formatPrice(value) {
      return value.toLocaleString('en-US');
    },
    updateDisplayValue(value) {
      const moneyPlus = this.mode.includes('money-plus') ? '+' : '';
      this.customDisplayValue = `$${this.formatPrice(value[0])} - $${this.formatPrice(value[1])} ${moneyPlus}`;
    },
    async updateCustomInputSlider() {
      const validation = await this.validCustomValue();
      if (validation) {
        this.syncCustomValues();
        // const roundedValues = await this.roundCustomInputValue();
        // if ( roundedValues ) {
        //   this.customInputValue = [roundedValues.min, roundedValues.max];
        //   this.syncCustomValues();
        // }
      } else {
        this.resetCustomValues();
      }
    },
    syncCustomValues() {
      this.customSliderInternalValue = [...this.customInputValue];
      this.customInputResetValue = [...this.customInputValue];
    },
    resetCustomValues() {
      this.customInputValue = [...this.customInputResetValue];
      this.customSliderInternalValue = [...this.customInputResetValue];
    },
    getFilterResult() {
      // if (this.forceLoading) this.$emit('force-loading', true); // force update result list
      this.displayValue.value = [...this.customInputValue];
    },
    selectInput(refName) {
      // this.$refs[input].value = '';
      this.$refs[refName].select();
    },
    validCustomValue() {
      const [min, max] = this.customInputValue;
      if (min > max || min.length === 0 || max.length === 0) {
        return false;
      }
      if (min < this.fixedRange[0]) {
        this.customInputValue[0] = this.fixedRange[0];
        return true;
      }
      if (max > this.fixedRange[1]) {
        this.customInputValue[1] = this.fixedRange[1];
        return true;
      }
      return true;
    },
    roundCustomInputValue() {
      return {
        min: this.roundToNearestStep(this.customInputValue[0]),
        max: this.roundToNearestStep(this.customInputValue[1]),
      };
    },
    roundToNearestStep(value) {
      const step = this.step;
      const remainder = value % step;
      return remainder >= step / 2 ? Math.ceil(value / step) * step : Math.floor(value / step) * step;
    },
    updateCustomInputValue(value) {
      this.customInputValue = [...value];
    },
  }
}
